export class TrainingsInAutoTrainingCodeModel {
    trainingsInAutoTrainingCodeId?: string;
    assignment: string;
    skill: string;
    skillId : string;
    application: string;
    taskCount: number;
    timeLimit: number;
    trainingOrder: number;
}

export class TrainingsInAutoTrainingCodeFullModel {
    trainingsInAutoTrainingCodeId?: string;
    assignment: string;
    skill: string;
    skillId: string;
    application?: string;
    taskCount?: number;
    timeLimit?: number;
    trainingOrder?: number;
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/communication-structure/trainings-in-auto-training-code-list.ts